/* Casino-wide progressive jackpot strip. Polls the SHARED pool endpoint so
   Balls of Fire, Lucky Ducky and Lucky Flamingo all show the same climbing
   Mini/Minor/Major/Mega values. Presentation only. */
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import './jackpot.css';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const POLL_URL = `${API}/games/balls-of-fire/jackpots`; // shared pool (legacy path)
const TIERS = ['MINI', 'MINOR', 'MAJOR', 'MEGA'];
const usd = (n) => '$' + Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function Chip({ tierKey, value }) {
  const [display, setDisplay] = useState(value);
  const [bump, setBump] = useState(false);
  const fromRef = useRef(value);
  useEffect(() => {
    if (value == null || value === display) return;
    const from = fromRef.current;
    const start = performance.now();
    const dur = 700;
    let raf;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / dur);
      const e = 1 - Math.pow(1 - t, 3);
      setDisplay(from + (value - from) * e);
      if (t < 1) raf = requestAnimationFrame(tick);
      else { fromRef.current = value; setBump(true); setTimeout(() => setBump(false), 420); }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return (
    <div className={`jp-chip jp-${tierKey.toLowerCase()}${bump ? ' bump' : ''}`} data-testid={`jackpot-${tierKey.toLowerCase()}`}>
      <span className="jp-chip-label">{tierKey}</span>
      <span className="jp-chip-val">{usd(display)}</span>
    </div>
  );
}

export function JackpotStrip({ className = '' }) {
  const [pools, setPools] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await axios.get(POLL_URL);
        if (alive && data?.tiers) setPools(data.tiers);
      } catch (_e) { /* keep last values */ }
    };
    load();
    const id = setInterval(load, 5000);
    return () => { alive = false; clearInterval(id); };
  }, []);
  return (
    <div className={`jp-strip ${className}`} data-testid="jackpot-strip">
      {TIERS.map((t) => (
        <Chip key={t} tierKey={t} value={pools ? (pools[t]?.current ?? pools[t]?.seed ?? 0) : null} />
      ))}
    </div>
  );
}

export default JackpotStrip;
